import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="11" viewBox="0 0 17 11">
    <path d="M11.2 5c1.2 0 2.2-1 2.2-2.2S12.4.6 11.2.6 9 1.5 9 2.8 10 5 11.2 5zm-6 0c1.2 0 2.2-1 2.2-2.2S6.4.6 5.2.6 3 1.5 3 2.8 4 5 5.2 5zm0 1.5C3.5 6.5 0 7.4 0 9.1V11h10.5V9.1c0-1.7-3.5-2.6-5.3-2.6zm6 0h-.7c.9.7 1.5 1.5 1.5 2.6V11h4.5V9.1c0-1.7-3.5-2.6-5.3-2.6z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/icon-users.es6.js